import { createStore, combineReducers } from "redux";
import conversation from "./reducers/conversation";
import contactInfo from "./reducers/contactInfo";
import message from "./reducers/message";
import conversationFilter from "./reducers/conversationFilter";
import conversationPreferenceReducer from "./reducers/conversationPreference";

const mirrorChatStore = createStore(combineReducers({conversation, contactInfo, message, conversationFilter, conversationPreferenceReducer}));

export default mirrorChatStore;